export default "__VITE_ASSET__D2BJyMh9__"